<h3 mat-dialog-title>Stop Using Account as a Payment Method?</h3>
<img (click)="closeDialog()" class="mat-close" src="/assets/images/payhoa/other/icon_close.svg">

<mat-dialog-content class="small-content">
    Are you sure you want to stop using {{data.account.friendlyName}} as a payment method?
</mat-dialog-content>

<mat-dialog-actions>
    <button (click)="closeDialog()" class="btn btn-outline-secondary">
        Cancel
    </button>
    <button (click)="removePaymentMethod()" [disabled]="requestInFlight" class="btn btn-primary">
        Remove Payment Method
    </button>
</mat-dialog-actions>
